import React, { Component } from 'react';
import { Container, Media, Row, Col, Card, CardTitle, CardText } from 'reactstrap';
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import Loading from '../Utilities/Loading'

class Trips extends Component {
  render() {
    const {auth, owned, participating} = this.props;
    if (!auth.uid) return <Redirect to='/login' />
    if (!owned) return <Loading/>
    if (!participating) return <Loading/>
    return (
      <Container>
      <h1 className="text-center display-3">My Trips</h1><br/>
      
      <Row>

        <Col md='6' sm='12' className='text-center'>
          <h2 className="text-center display-4">Owned</h2>
          {owned && owned.map(event => (
            <Link to={`/event/${event.id}`} style={{ color: 'white' }} key={event.id}>
              <h2>{event.title}</h2>
            </Link>
          ))}
        </Col>

        <Col md='6' sm='12' className='text-center'>
          <h2 className="text-center display-4">Participating</h2>
          {participating && participating.map(event => (
            <Link to={`/event/${event.eventID}`} style={{ color: 'white' }} key={event.id}>
              <h2>{event.eventName} ({event.role})</h2>
            </Link>
          ))}
        </Col>
    </Row>
    </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.firebase.auth,
      owned: state.firestore.ordered.events,
      participating: state.firestore.ordered.participants
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    if (!props.auth.uid) return []
    return [
    { collection: 'events', where: ['owner', '==', props.auth.uid] },
    { collection: 'participants', where: ['user', '==', props.auth.uid] }
    ]})
)(Trips)